// extracted by mini-css-extract-plugin
module.exports = {"card":"FileArtifactCard_card__4xteJ"};